export default __webpack_public_path__ + "static/media/epm-1.71229622.png";